import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    OnInit,
    ElementRef,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CommonLookupServiceProxy,
    StockTransferServiceProxy,
    CreateOrEditStockTransferDto,
    FindVendorOutputDto,
    DropDownLookupDto,
    FindProductOutputDto,
    Status,
    ApplicableUnitForProduct,
    CreateOrEditStockTransferDetailDto,
    GetStockTransferForEditInput,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { debug } from 'console';
import { forEach } from 'lodash-es';

@Component({
    templateUrl: './create-or-edit-stockreceive.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditStockReceiveComponent extends AppComponentBase implements OnInit {
    @ViewChildren('itemCodeInput') itemCodeInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('qtyInput') qtyInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('costInput') costInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('focQtyInput') focQtyInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('itemDiscountPercInput') itemDiscountPercInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('itemDiscountInput') itemDiscountInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('taxInput') taxInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('addButton') addButtons!: QueryList<ElementRef<HTMLButtonElement>>;
    active = false;
    saving = false;
    productSelectedItem: FindProductOutputDto;
    products: FindProductOutputDto[];
    units: any[] = [];
    fromLocation = '';
    stockTransfer: CreateOrEditStockTransferDto = new CreateOrEditStockTransferDto();
    stockTransferDetails: CreateOrEditStockTransferDetailDto[];
    stockTransferDetail: CreateOrEditStockTransferDetailDto = new CreateOrEditStockTransferDetailDto();
    status = Status;
    receivedQty = 0;
    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('StockReceive'), '/app/stock/stockreceive'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _stockTransferServiceProxy: StockTransferServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,

    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.fromLocation = this.appSession.user.locationName;
        this.show(this._activatedRoute.snapshot.queryParams['id']);
        this.addRow(0);

    }

    removeItem(index: number) {
        this.stockTransferDetails.splice(index, 1);

        if (this.stockTransferDetails.length == 0) {
            this.addRow(index);
        }

        var i = 1;
        this.stockTransferDetails.forEach((c) => {
            c.slNo = i++;
        });

        this.productSelectedItem = null;
    }

    searchProduct(productCode: string, data: CreateOrEditStockTransferDetailDto, index: number) {
        this._commonLookupServiceProxy
            .getProductDetail(undefined, productCode, undefined, 'Purchase',0, this.appSession.user.locationId)
            .subscribe((result) => {
                if (result.productId > 0) {
                    this.focusNext('qty', index);
                    data.productId = result.productId;
                    data.cost = result.unitCost;
                    data.productName = result.productName;
                    data.productCode = result.productCode;
                    data.cost = result.unitCost;
                    data.price = result.price;
                    data.applicableUnits = result.applicableUnits;
                    /*  data.applicableTaxes = result.applicableTaxes;*/
                    data.unitId = result.unitId;
                    data.qty = 1;
                    if (data.productSelectedItem == null) {
                        data.productSelectedItem = new FindProductOutputDto();
                        data.productSelectedItem.id = data.productId;
                        data.productSelectedItem.displayName = data.productName;
                        //this.productSelectedItem.code = result.productCode;
                    }
                    this.changeUnit(data);
                } else {
                    abp.notify.error('ProductNotFound');
                    data.productCode = '';
                }
            });
    }

    focusNext(type: 'qty' | 'cost' | 'focQty' | 'itemDiscountPerc' | 'itemDiscount' | 'tax' | 'add' | 'nextRow', index: number) {
        if (type === 'qty') {
            const next = this.qtyInputs.get(index);
            next?.nativeElement.focus();
            setTimeout(() => next.nativeElement.select(), 0);
        } else if (type === 'cost') {
            const next = this.costInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'focQty') {
            const next = this.focQtyInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'itemDiscountPerc') {
            const next = this.itemDiscountPercInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'itemDiscount') {
            const next = this.itemDiscountInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'tax') {
            const next = this.taxInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'add') {
            const next = this.addButtons.get(index);
            next?.nativeElement.focus();
        } else if (type === 'nextRow') {
            if (index === this.stockTransferDetails.length - 1) {
                this.addRow(index);
                setTimeout(() => {
                    const nextItem = this.itemCodeInputs.get(index + 1);
                    nextItem?.nativeElement.focus();
                });
            } else {
                const nextItem = this.itemCodeInputs.get(index + 1);
                nextItem?.nativeElement.focus();
            }
        }
    }

    addRow(index: number): void {
        if (this.stockTransferDetails == null) this.stockTransferDetails = [];

        this.stockTransferDetail = new CreateOrEditStockTransferDetailDto();
        this.stockTransferDetail.slNo = this.stockTransferDetails.length + 1;
        this.stockTransferDetails.push(this.stockTransferDetail);
        //const nextItem = this.itemCodeInputs.get(index + 1);
        //nextItem?.nativeElement.focus();
    }

    changeUnit(data: any): void {
        data.changeUnitFlag = true;
        this.fillDropDownUnitBasedOnProduct(data.productId, data);
    }

    fillDropDownUnitBasedOnProduct(selectProductId: number, data: CreateOrEditStockTransferDetailDto): void {

        this._commonLookupServiceProxy.getUnitForProductCombobox(selectProductId).subscribe({
            next: (result: any) => {

                if (!(data.unitId > 0 && data.qty > 0)) {
                    data.unitId = data.unitId;
                    data.unitName = data.unitName;
                }
                this.amountCalculate(data);
                this.calculateTotalValues();
            },
            error: () => { },
        });
    }

    show(addStockId?: number): void {
        if (!addStockId) {
            this.stockTransfer = new CreateOrEditStockTransferDto();
            this.stockTransfer.id = addStockId;
            this.stockTransfer.transferDate = this._dateTimeService.getStartOfDay();

            this.active = true;
            this.stockTransfer.locationId = this.appSession.user.locationId;
            this.stockTransfer.status = Status.Draft;
        } else {
            this._stockTransferServiceProxy.getStockReceiveForEdit(addStockId).subscribe((result) => {
                this.stockTransfer = result.stockTransfer;
                this.stockTransferDetails = result.stockTransferDetails;
                this.stockTransfer.transferQty = 0;

                this.fromLocation = result.fromLocation;
                this.stockTransferDetails.forEach((c) => {
                    c.buttonLabel = c.isStockReceiveReturn == null || c.isStockReceiveReturn == false ? this.l('Return') : this.l('Returned')
                });

                this.active = true;

                if (this._activatedRoute.snapshot.queryParams['dirinv'] == 0) {
                    this.stockTransfer.id = null;
                    this.stockTransfer.status = this.status.Draft;
                }
                this.calculateTotalValues();
            });
           
        }
    }

    getCurrencyRate(value: any): void {
        this.calculateTotalValues();
    }

    amountCalculate(data: CreateOrEditStockTransferDetailDto) {
        data.totalCost = Number(data.cost) * (Number(data.qtyToReceive) + Number(data.receivedQty));
        data.totalCost = Number(data.price) * (Number(data.qtyToReceive) + Number(data.receivedQty));
        data.diffQty = (data.qty - data.receivedQty - data.qtyToReceive);
        this.calculateTotalValues();
    }

    calculateTotalValues(): void {
        var data = this.stockTransferDetails;
        let totalQty = 0;
        let totalCost = 0;
        let totalPrice = 0;
        let receivedQty = 0;

        this.stockTransferDetails.forEach((val) => {
            totalCost = Number(totalCost) + Number(val.totalCost); 
            totalPrice = Number(totalPrice) + Number(val.totalPrice);
            debugger
            totalQty = Number(totalQty) + Number(val.qtyToReceive);
            receivedQty = Number(receivedQty) + Number(val.receivedQty);
        });

        this.stockTransfer.transferTotal = totalCost;
        this.stockTransfer.transferTotalPrice = totalPrice;
        this.stockTransfer.transferQty = totalQty;
        this.receivedQty = receivedQty;
    }

    save(): void {
        this.saving = true;
        var stockTransferInput = new GetStockTransferForEditInput();
        stockTransferInput.stockTransfer = this.stockTransfer;
        stockTransferInput.stockTransferDetails = this.stockTransferDetails;

        var totalQty = 0;
        var totalReceivedQty = 0;
        var totalReceiveQty = 0;
        var isStockTransfered = false;

        stockTransferInput.stockTransferDetails.forEach(val => {
            val.receivedQty = val.qtyToReceive;
            totalReceiveQty = Number(totalReceiveQty) + Number(val.qtyToReceive);

            if (val.isStockReceiveReturn == true) {
                totalReceivedQty = Number(totalReceivedQty) + Number(val.qty) + Number(val.qtyToReceive) + Number(val.receivedQty);
                totalQty = Number(totalQty) + Number(val.qty);

            }
            else {
                if (val.qty != val.receivedQty) {

                    totalReceivedQty = Number(totalReceivedQty) +
                        Number(val.qtyToReceive) + Number(val.receivedQty);
                    totalQty = Number(totalQty) + Number(val.qty);
                }
            }
        });

        if (Number(totalReceivedQty) == Number(totalQty)) {
            stockTransferInput.stockTransfer.status = Status.Received;
        }
        else if (Number(totalReceivedQty) > Number(totalQty)) {
            stockTransferInput.stockTransfer.status = Status.Received;
        }
        else if (Number(totalReceivedQty) < Number(totalQty)) {
            stockTransferInput.stockTransfer.status = Status.Partial;
        }

        this._stockTransferServiceProxy
            .updateStockReceive(stockTransferInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.goBack();
            });
    }


    returnStockTransfer(data: CreateOrEditStockTransferDetailDto): void {
        data.isStockReceiveReturn = true;
        data.buttonLabel = this.l('Returned');
    }
    
    receiveAll(): void {
       
        this.stockTransferDetails.forEach(value => {

            if (value.qty == value.receivedQty) {
                return;
            }

            if (value.buttonLabel == "Returned") {
                return;
            }

            if (value.receivedQty == 0) {
                value.qtyToReceive = value.qty - value.receivedQty;
                value.diffQty = value.qty - value.qtyToReceive;
                value.totalCost = value.qtyToReceive * value.cost;
            }
            else {
                value.qtyToReceive = value.qty - value.receivedQty;
                value.diffQty = value.qty - (value.receivedQty + value.qtyToReceive);
                value.totalCost = value.qtyToReceive * value.cost;
            }
        });

        this.calculateTotalValues();
    }

    getProduct(product: FindProductOutputDto, data: CreateOrEditStockTransferDetailDto, index: number) {
        this.productSelectedItem = product;
        this.stockTransferDetails[index].productSelectedItem = product;
        this.searchProduct(product.code, data, index);
    }

    goBack(): void {
        this._router.navigate(['/app/stock/stockreceive']);
    }
}
